var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 9,
    viewBox: "0 0 23 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.96 0.639999V8H2.12V5.21H3.23C4.83 5.21 6 4.47 6 2.86C6 1.21 4.83 0.639999 3.19 0.639999H0.96ZM3.12 4.28H2.12V1.57H3.08C4.25 1.57 4.86 1.89 4.86 2.86C4.86 3.83 4.33 4.28 3.12 4.28ZM7.33461 2.5V8H8.47461V4.57C8.82461 3.7 9.36461 3.39 9.81461 3.39C10.0446 3.39 10.1746 3.41 10.3646 3.48L10.5746 2.48C10.4046 2.4 10.2246 2.36 9.95461 2.36C9.35461 2.36 8.78461 2.77 8.39461 3.49H8.36461L8.27461 2.5H7.33461ZM13.6364 8.13C14.9964 8.13 16.2264 7.07 16.2264 5.26C16.2264 3.42 14.9964 2.36 13.6364 2.36C12.2764 2.36 11.0464 3.42 11.0464 5.26C11.0464 7.07 12.2764 8.13 13.6364 8.13ZM13.6364 7.19C12.7864 7.19 12.2364 6.42 12.2364 5.26C12.2364 4.09 12.7564 3.31 13.6364 3.31C14.5164 3.31 15.0464 4.09 15.0464 5.26C15.0464 6.42 14.5064 7.19 13.6364 7.19ZM19.109 4.71V6.87H19.989V4.71H22.019V3.87H19.989V1.71H19.109V3.87H17.079V4.71H19.109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProPlus);
export default __webpack_public_path__ + "static/media/proPlus.818cc5a0f39279f97b6ccdfd05648bf0.svg";
export { ForwardRef as ReactComponent };